module.exports = __webpack_public_path__ + "img/bornutti_skizze4.8cc31fe7.jpg";